// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileExclamationFilledSvg from "@fishx/icons-svg/es/asn/FileExclamationFilled";
import FishxIcon from '../components/FishxIcon';

var FileExclamationFilled = function FileExclamationFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileExclamationFilledSvg
  }));
};

FileExclamationFilled.displayName = 'FileExclamationFilled';
export default React.forwardRef(FileExclamationFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FileExclamationFilled.js
// module id = 2693
// module chunks = 0